<template>
  <div class=''>
    <Headers :widthmun='windowWidth'/>
    <div class="new_box">
        <div class="container sp">
            <!-- <el-row>
                <el-col :span="24">
                    <div class="col_list">
                        <el-breadcrumb separator="/">
                        <el-breadcrumb-item :to="{ path: '/' }">{{$t('home.home')}}</el-breadcrumb-item>
                        <el-breadcrumb-item>{{$t('commodity.nftassets')}}</el-breadcrumb-item>
                        <el-breadcrumb-item>{{$t('commodity.nftassets')}}</el-breadcrumb-item>
                        </el-breadcrumb>
                    </div>
                </el-col>
            </el-row> -->
        
        </div>
    </div>

    <!-- 返回栏 -->
    <div class="ban_box bg_box" v-if="routertype == '2'">
      <p @click="gotopath()"><img src="../../assets/img/fanhui.png"  style="margin-right:10px;margin-bottom:2px" alt="">{{$t('nftmarket.title')}}</p>
    </div>
    <div class="ban_box bg_box" v-if="routertype == '1'">
      <p @click="gotopath()" ><img src="../../assets/img/fanhui.png" style="margin-right:10px;margin-bottom:2px" alt="">{{$t('nftmarket.title')}}</p>
    </div>

    <div class="divder_box">
      <el-divider></el-divider>
    </div>

    <!-- 内容区 -->
    <div class="ban_box banner_box" v-loading="loadingbanner">
      <!-- 图片 -->
      <div class="first_flex">
        <div class="img_box" v-loading="loading" ref="barparent">
          <img :src="form.imageURI"  @load="changeloading(form.imageURI)" style="width:100%" alt="">
        </div>

        <div style="padding-top:20px" v-show="windowWidth<=980">
          <div class="right_box">
            <div>
              <h3>{{ form.name }}</h3>
            </div>
            <div class="top_btn_box">
              <!-- <el-button class="bg_btn" v-if="btnList.editButton" @click="edit()">{{$t('nftmarket.c6')}}</el-button>
              <el-button type="primary" v-if="btnList.sellButton" @click="sell()">{{$t('nftmarket.c7')}}</el-button>
              <el-button class="bg_btn" v-if="btnList.cancelButton" @click="changesell()">{{$t('nftmarket.c8')}}</el-button> -->
              <!-- <el-button type="primary" @click="dialogFormVisible = true" v-if="1==2">Lower Price</el-button> -->
            </div>

            <!-- <el-dialog width='500px'  :visible.sync="dialogFormVisible">
              <p style="text-align:center;">
                  <img src="../../assets/img/qukuan.png" style="text-align:center;margin:0 auto" alt="">
              </p>
              <p style="text-align:center;" class="dialog_box_p">Lower the listing price</p>
              <div style="text-align:center;margin-bottom:50px;">
                <el-select v-model="category" style="width:65%" placeholder="Art">
                  <el-option
                      v-for="item in categories"
                      :key="item.id"
                      :label="item.name"
                      :value="item.id"
                  ></el-option>
                </el-select>
              </div>
              <div style="text-align:center;">
                <el-button class="bg_btn" @click="dialogFormVisible = false">Cancel</el-button>
                <el-button type="primary">Continue</el-button>
              </div>
            </el-dialog> -->
          </div>
          <div class="right_box">
            <div style="display:flex">
              <div class="yuan"></div>
              <p>{{$t('nftmarket.c9')}}</p>
              <span>{{ form.owner }}</span>
              <p style="margin-left:47px">{{$t('nftmarket.c10')}}{{ form.categoryName }}</p>
            </div>
          </div>
          <div class="">
            <el-tag v-if="form.status=='1'">{{$t('commodity.c26')}}</el-tag>
            <el-tag v-if="form.status=='2'">{{$t('commodity.c27')}}</el-tag>
            <el-tag v-if="form.status=='3'" type="danger">{{$t('commodity.c28')}}</el-tag>
            <el-tag v-if="form.status=='5'" type="danger">{{$t('commodity.c29')}}</el-tag>
            <el-tag v-if="form.status=='6'">{{$t('commodity.c30')}}</el-tag>
            <el-tag v-if="form.status=='7'">{{$t('commodity.c31')}}</el-tag>
            <el-tag v-if="form.status=='8'" type="success">{{$t('commodity.c32')}}</el-tag>
          </div>
        </div>

        <div class="collpass_box">
          <el-collapse v-model="formdata.activeName" accordion>
            <el-collapse-item name="1">
              <template slot="title">
                <img src="../../assets/img/Description.png" style="width:23px;height:19px;margin-right:15px" alt="">
                {{$t('nftmarket.c1')}}
              </template>
              <div>{{form.description }}
              </div>
            </el-collapse-item>
          </el-collapse>
        </div>

        <div class="collpass_box">
          <el-collapse v-model="formdata.Details" accordion>
            <el-collapse-item name="1">
              <template slot="title">
                <img src="../../assets/img/Details.png" style="width:22px;height:22px;margin-right:15px" alt="">
                {{$t('nftmarket.c2')}}
              </template>
              <div class="coll_flex">
                <p>{{$t('nftmarket.c3')}}</p>
                <p style="color:#2181E2"><a :underline="false" target="_blank" :href="form.contractAddressUrl">{{form.contractAddress  | ellipsis }}</a></p>
              </div>
              <div class="coll_flex">
                <p style="text-align:left">{{$t('nftmarket.c4')}}</p>
                <p style="color:#353840">{{form.tokenId }}</p>
              </div>
              <div class="coll_flex">
                <p>{{$t('nftmarket.c5')}}</p>
                <p style="color:#2181E2"><a :underline="false" target="_blank" :href="form.transactionHashUrl">{{form.transactionHash | ellipsis}}</a></p>
              </div>
            </el-collapse-item>
          </el-collapse>
        </div>
      </div>
      <!-- 信息 -->
      <div class="two_flex">

        <div v-show="windowWidth>980">
          <div class="right_box">
            <div>
              <h3>{{ form.name }}</h3>
            </div>
            <div class="top_btn_box">
              <!-- <el-button class="bg_btn" v-if="btnList.editButton" @click="edit()">{{$t('nftmarket.c6')}}</el-button>
              <el-button type="primary" v-if="btnList.sellButton" @click="sell()">{{$t('nftmarket.c7')}}</el-button>
              <el-button class="bg_btn" v-if="btnList.cancelButton" @click="changesell()">{{$t('nftmarket.c8')}}</el-button> -->
              <!-- <el-button type="primary" @click="dialogFormVisible = true" v-if="1==2">Lower Price</el-button> -->
            </div>

            <!-- <el-dialog width='500px'  :visible.sync="dialogFormVisible">
              <p style="text-align:center;">
                  <img src="../../assets/img/qukuan.png" style="text-align:center;margin:0 auto" alt="">
              </p>
              <p style="text-align:center;" class="dialog_box_p">Lower the listing price</p>
              <div style="text-align:center;margin-bottom:50px;">
                <el-select v-model="category" style="width:65%" placeholder="Art">
                  <el-option
                      v-for="item in categories"
                      :key="item.id"
                      :label="item.name"
                      :value="item.id"
                  ></el-option>
                </el-select>
              </div>
              <div style="text-align:center;">
                <el-button class="bg_btn" @click="dialogFormVisible = false">Cancel</el-button>
                <el-button type="primary">Continue</el-button>
              </div>
            </el-dialog> -->
          </div>
          <div class="right_box">
            <div style="display:flex">
              <div class="yuan"></div>
              <p>{{$t('nftmarket.c9')}}</p>
              <span>{{ form.owner }}</span>
              <p style="margin-left:47px">{{$t('nftmarket.c10')}}{{ form.categoryName }}</p>
            </div>
          </div>
          <div class="">
            <el-tag v-if="form.status=='1'">{{$t('commodity.c26')}}</el-tag>
            <el-tag v-if="form.status=='2'">{{$t('commodity.c27')}}</el-tag>
            <el-tag v-if="form.status=='3'" type="danger">{{$t('commodity.c28')}}</el-tag>
            <el-tag v-if="form.status=='5'" type="danger">{{$t('commodity.c29')}}</el-tag>
            <el-tag v-if="form.status=='6'">{{$t('commodity.c30')}}</el-tag>
            <el-tag v-if="form.status=='7'">{{$t('commodity.c31')}}</el-tag>
            <el-tag v-if="form.status=='8'" type="success">{{$t('commodity.c32')}}</el-tag>
          </div>
        </div>
        

        <div class="collpass_box bg_coll_box">
          <el-collapse v-model="formdata.Sale" accordion>
            <el-collapse-item name="1">
              <template slot="title">
                <img src="../../assets/img/shijian_icon.png" style="width:20px;height:20px;margin-right:15px" alt="">
                <p style="font-weight:500;margin:0" v-if="offerslist.expirationDate">
                  {{$t('nftmarket.c11')}}
                  <span style="font-weight:600">{{ formatDay(offerslist.expirationDate) }} {{$t('nftmarket.c12')}}</span>
                  <span style="color:#8A949C;margin-left:15px">({{formatDateTime(offerslist.expirationDate)  }})</span>
                </p>
              </template>
              <div class="collmon_box">
                <p v-show="offerslist.highestBidStatus == '1'">{{$t('nftmarket.c13')}}</p>
                <p v-show="offerslist.highestBidStatus == '2'">{{$t('nftmarket.c131')}}</p>
                <p v-show="offerslist.highestBidStatus == '3'">{{$t('nftmarket.c132')}}</p>
                <h3>
                  {{ offerslist.currentPrice }}
                  <p> {{ offerslist.currentCurrency }} </p>
<!--                  <span>($44,693.88)</span>-->
                </h3>
                <el-button v-if="btnList.buyNowButtoon" class="buy_btn" type="primary" @click="dialogbuyNowVisible = true">
                  <img src="../../assets/img/qianbao.png" alt="">
                  {{$t('nftmarket.c14')}}
                </el-button>
                <el-button v-if="btnList.placeBidButton" class="buy_btn" type="primary" @click="dialogBidVisible = true">
                  <img src="../../assets/img/qianbao.png" alt="">
                  {{$t('nftmarket.c15')}}
                </el-button>
              </div>
            </el-collapse-item>
          </el-collapse>

          <!-- buyNow 弹出框 -->
          <el-dialog width='600px'  :visible.sync="dialogbuyNowVisible">
            <p style="text-align:center;">
                <img src="../../assets/img/Makeanoffer.png" style="text-align:center;margin:0 auto" alt="">
            </p>
            <p style="text-align:center;" class="dialog_box_p">{{$t('nftmarket.c16')}}</p>
            
            <el-form :model="buynowform" label-width="150px">
              <el-form-item label="Trading Account:" prop="Price">
                <el-select v-model="buynowform.tradingAccount" style="width:100%;" clearable :placeholder="$t('nftmarket.c17')">
                  <el-option
                      style="width:100%;"
                      v-for="(item,index) in accountList"
                      :key="index"
                      :label="item.accountId"
                      :value="item.accountId"
                  ></el-option>
                </el-select>
              </el-form-item>
            </el-form>
            <div style="text-align:center;">
              <el-button type="primary" :disabled="changebuyNow()" :loading="buyNowbool" @click="buyNow">{{$t('nftmarket.c14')}}</el-button>
              <!-- <el-button type="primary">Add Funds</el-button> -->
            </div>
          </el-dialog>

          <!-- Place Bid 弹出框 -->
          <el-dialog width='600px'  :visible.sync="dialogBidVisible">
            <p style="text-align:center;">
                <img src="../../assets/img/Makeanoffer.png" style="text-align:center;margin:0 auto" alt="">
            </p>
            <p style="text-align:center;" class="dialog_box_p">{{$t('nftmarket.c15')}}</p>
            
            <el-form :model="formdatas" class="dia_sele_box" label-width="150px">
              <el-form-item label="Price" prop="Price">
                <div style="display:flex">
                  <el-select v-model="formdatas.currency" style="width:130px;margin-right:10px" placeholder="Art">
                    <el-option
                        v-for="(item,index) in currencyList"
                        :key="index"
                        :label="item.id"
                        :value="item.id">
                    </el-option>
                  </el-select>
                  <el-input placeholder="Amount" v-model="formdatas.price" oninput="value=value.replace(/[^\d.]/g, '').replace(/\.{2,}/g, '.').replace('.', '$#$').replace(/\./g, '').replace('$#$', '.').replace(/^(\-)*(\d+)\.(\d\d).*$/, '$1$2.$3').replace(/^\./g, '')"  class="input-with-select"/>
                </div>
                
              </el-form-item>

              <el-form-item label="Trading Account:" prop="Price">
                <el-select v-model="formdatas.payAccount" style="width:100%;" clearable :placeholder="$t('nftmarket.c17')">
                  <el-option
                      style="width:100%;"
                      v-for="(item,index) in accountList"
                      :key="index"
                      :label="item.accountId"
                      :value="item.accountId"
                  ></el-option>
                </el-select>
              </el-form-item>

              <el-form-item label="Offer Expiration" prop="Price">
                  <el-date-picker
                    style="width:100%"
                    v-model="formdatas.expirationDate"
                    type="datetime"
                    align="right"
                    value-format="yyyy-MM-dd HH:mm:ss"
                    @change="handledate(formdatas.expirationDate)"
                    :picker-options="pickerOptions">
                  </el-date-picker>
                  
              </el-form-item>
            </el-form>
            <div style="text-align:center;">
              <el-tooltip class="item" :disabled="changemakeoffs()" effect="dark" :content="$t('nftmarket.c155')" placement="top">
                <div style="width:100px;margin:0 auto">
                  <el-button type="primary" :disabled="changemakeoff()" :loading="makeoffbool" @click="postMakeoffer">{{$t('nftmarket.c15')}}</el-button>
                </div>
              </el-tooltip>
              <!-- <el-button type="primary">Add Funds</el-button> -->
            </div>
          </el-dialog>
        </div>

        <div class="collpass_box">
          <el-collapse v-model="formdata.Offers" accordion>
            <el-collapse-item name="1">
              <template slot="title">
                <img src="../../assets/img/icon_menu.png" style="width:25px;height:16px;margin-right:15px" alt="">{{$t('nftmarket.c18')}}
              </template>
              <div>
                <el-table :cell-style="columnStyle" :data="offerslist.offerList" stripe style="width: 100%">
                  <el-table-column :label="$t('nftmarket.c19')">
                    <template slot-scope="scope">
                      <span>{{ scope.row.price }}<span>{{ scope.row.currency }}</span></span>
                    </template>
                  </el-table-column>
                  <el-table-column :label="$t('nftmarket.c199')">
                    <template slot-scope="scope">
                      <span><span style="font-size:12px;margin-left:5px">$</span>{{ scope.row.priceUsd }}</span>
                    </template>
                  </el-table-column>
                  <el-table-column :label="$t('nftmarket.c20')">
                    <template slot-scope="scope">
                      <span>{{ formatDateTime(scope.row.expirationDate) }}</span>
                    </template>
                  </el-table-column>
                  <el-table-column prop="fromUser" :label="$t('nftmarket.c21')"></el-table-column>
                  <el-table-column>
                    <template slot-scope="scope">
                      <div class="right_btn_box">
                        <!-- <el-button type="primary" @click="changeCancel(scope.row)" size="mini" plain>Cancel<i class="el-icon-arrow-right"></i></el-button>
                        <el-button type="primary" @click="changeAccept(scope.row)" size="mini" plain>Accept<i class="el-icon-arrow-right"></i></el-button> -->
                        <el-button  v-if="scope.row.cancelOfferButton" :loading="cancelbool" @click="changeCancel(scope.row)" size="mini" plain>{{$t('nftmarket.c22')}}<i class="el-icon-arrow-right"></i></el-button>
                        <el-button  v-if="scope.row.acceptOfferButton" :loading="acceptbool" @click="changeAccept(scope.row)" size="mini" plain>{{$t('nftmarket.c23')}}<i class="el-icon-arrow-right"></i></el-button>
                      </div>
                    </template>
                  </el-table-column>
                </el-table>
                <el-button class="bg_btn_box" v-if="btnList.makeOfferButton" @click="dialogmakeVisible = true">{{$t('nftmarket.c24')}}</el-button>
              </div>
            </el-collapse-item>
          </el-collapse>

          <!-- make offer 弹出框 -->
          <el-dialog width='600px'  :visible.sync="dialogmakeVisible">
            <p style="text-align:center;">
                <img src="../../assets/img/Makeanoffer.png" style="text-align:center;margin:0 auto" alt="">
            </p>
            <p style="text-align:center;" class="dialog_box_p">{{$t('nftmarket.c25')}}</p>
            
            <el-form :model="formdatas" class="dia_sele_box" label-width="150px">
              <el-form-item label="Price" prop="Price">
                <div style="display:flex">
                  <el-select v-model="formdatas.currency" style="width:130px;margin-right:10px"  placeholder="Art">
                    <el-option
                        v-for="(item,index) in currencyList"
                        :key="index"
                        :label="item.id"
                        :value="item.id">
                    </el-option>
                  </el-select>
                  <el-input placeholder="Amount" v-model="formdatas.price" oninput="value=value.replace(/[^\d.]/g, '').replace(/\.{2,}/g, '.').replace('.', '$#$').replace(/\./g, '').replace('$#$', '.').replace(/^(\-)*(\d+)\.(\d\d).*$/, '$1$2.$3').replace(/^\./g, '')" class="input-with-select">
                  </el-input>
                </div>
                
                  
                
              </el-form-item>

              <el-form-item label="Trading Account:" prop="Price">
                <el-select v-model="formdatas.payAccount" style="width:100%;" clearable :placeholder="$t('nftmarket.c17')">
                  <el-option
                      style="width:100%;"
                      v-for="(item,index) in accountList"
                      :key="index"
                      :label="item.accountId"
                      :value="item.accountId"
                  ></el-option>
                </el-select>
              </el-form-item>

              <el-form-item label="Offer Expiration" prop="Price">
                  <el-date-picker
                    style="width:100%"
                    v-model="formdatas.expirationDate"
                    type="datetime"
                    align="right"
                    value-format="yyyy-MM-dd HH:mm:ss"
                    @change="handledate(formdatas.expirationDate)"
                    :picker-options="pickerOptions">
                  </el-date-picker>
                  
              </el-form-item>
            </el-form>
            <div style="text-align:center;">
              <el-tooltip class="item" :disabled="changemakeoffs()" effect="dark" :content="$t('nftmarket.c155')" placement="top">
                <div style="width:100px;margin:0 auto">
                  <el-button type="primary" :disabled="changemakeoff()" :loading="makeoffbool" @click="postMakeoffer">{{$t('nftmarket.c24')}}</el-button>
                </div>
              </el-tooltip>
              
              <!-- <el-button type="primary">Add Funds</el-button> -->
            </div>
          </el-dialog>
        </div>
      </div>
    </div>

    <!-- <Footer :widthmun='windowWidth'/> -->
  </div>
</template>

<script>
// 这里可以导入其他文件（比如：组件，工具js，第三方插件js，json文件，图片文件等等）
// 例如：import 《组件名称》 from '《组件路径》';
import Headers from '@/components/Header/index.vue'
import Footer from '@/components/Footer/index.vue';
import {mapState} from "vuex";
import authority from '@/api/authority'
import {formatDateTime,formatDay} from "@/util/date";

export default {
  // import引入的组件需要注入到对象中才能使用
  components: {Headers,Footer},
  data() {
    // 这里存放数据
    return {
      token:'',
      path:this.$route.query.path,
      id: this.$route.query.id,
      routertype:this.$route.query.type,
      dialogFormVisible:false,
      buyNowbool:false,
      acceptbool:false,
      cancelbool:false,
      makeoffbool:false,
      dialogmakeVisible:false,
      dialogbuyNowVisible:false,
      dialogBidVisible:false,
      windowWidth: document.documentElement.clientWidth,  //实时屏幕宽度
      // form:{
      //   category:'',
      // },
      category:'',
      loading: true,
      loadingbanner:true,
      buynowform:{
        tradingAccount:'',
      },
      formdata: {
        activeName: '1',
        Details: '1',
        Sale: '1',
        Offers: '1'
      },
      buynow:{
        tokenId:'',
        buyerAccount:'',
        price:'',
        currency:'',
      },
      formdatas: {
        tokenId:'',
        price: '',
        currency: 'EUR',
        expirationDate: '',
        payAccount:'',
      },
      pickerOptions: {
        disabledDate (time) {
          return time.getTime() < Date.now()-1 * 24 * 3600 * 1000
        },
      },
    }
  },
  // 监听属性 类似于data概念
  computed: {
    ...mapState({
      form: state => state.nft.item,
      categories: (state) => state.nft.categories,
      currencyList: function (state) {
        return state.nft.currencyList.filter((i) => !i.crypto);
      },
      btnList:state => state.nft.btnList,
      offerslist:state => state.nft.offerslist,
      accountList: (state) => state.nft.accountList
    })},
  filters: {
		ellipsis (value) {
      if (!value) return ''
      let len=value.length;
      if (value.length > 20) {
        return value.substring(0,6) + '......' +value.substring(len-6,len)
      }
      return value
		}
	},
  // 监控data中的数据变化
  watch: {
    btnList(newval,oldval){
      if(newval){
        this.loadingbanner = false
      }
    },
    windowWidth (val) {
        let that = this;
        this.windowWidth = val
      },
  },
  // 方法集合
  methods: {
    formatDateTime: formatDateTime,
    formatDay: formatDay,
    gotopath() {

      // 逻辑跳转路由，勿删！！！
      if(this.$route.query.type == '1'){
        this.$router.push({path: '/nftmarket'})
      }else{
        this.$router.push({path: '/nftmarket'})
      }
      
    },
    gotoLoginPage(){
      authority.seturl(this.$route.fullPath)
      authority.getOauthLoginUrl(response =>{
        window.location = response.loginUrl
      })
    },
    edit() {
      // 逻辑跳转路由，勿删！！！
      this.$router.push({path: '/createprofile', query: {id:this.form.id,type:this.$route.query.type}})
    },
    sell() {
      // 逻辑跳转路由，勿删！！！
      this.$router.push({path: '/setting', query: {tokenId:this.form.id, type: this.$route.query.type}})
    },
    changesell(){
      if(this.token){
        if(this.$i18n.locale == "en-us"){
          this.$confirm("Are you sure you're canceling the sale?", '', {
            confirmButtonText: 'Confirm',
            cancelButtonText: 'Cancel',
            type: 'warning'
          }).then(() => {
            this.$store.dispatch("nft/changesell", {tokenId:this.form.id})
            this.$nextTick(() =>{
              this.$message({
                type: 'success',
                message: 'Cancel success!'
              });
              location.reload();
              // this.$store.dispatch("nft/getTokenById", this.id);
            })
          }).catch(() => {
                    
          });
        }else{
          this.$confirm('您确定要取消交易吗？', '', {
            confirmButtonText: '确定',
            cancelButtonText: '取消',
            type: 'warning'
          }).then(() => {
            this.$store.dispatch("nft/changesell", {tokenId:this.form.id})
            this.$nextTick(() =>{
              this.$message({
                type: 'success',
                message: '取消成功!'
              });
              this.$store.dispatch("nft/getTokenById", this.id);
            })
          }).catch(() => {
                    
          });
        }
      }else{
        this.gotoLoginPage()
      }
      
      
    },
    buyNow(){
      if(this.token){
        let self = this;
        self.buyNowbool = true
        let request = self.buyNow
        request = {
          tokenId:this.form.id,
          buyerAccount:this.buynowform.tradingAccount,
          price:this.offerslist.currentPrice,
          currency:this.offerslist.listingCurrency
        }
        self.$store.dispatch("nft/buyNow", request)
        request.callback = function(response){
            if(response.result == 'success'){
              self.$message({type: "success", message: "Buy Successfully!"});
              self.buyNowbool = false
              self.$store.dispatch("nft/getTokenById", self.id);
              self.dialogbuyNowVisible = false
            }else{
              self.$message({type: "error", message: response.result});
              self.buyNowbool = false
              self.dialogbuyNowVisible = false
            }
          }
      }else{
        this.gotoLoginPage()
      }
      
    },
    changemakeoff(){
      if(this.offerslist.minimumBid){
        if(this.formdatas.price && this.formdatas.currency && this.formdatas.expirationDate && this.formdatas.payAccount && ((this.formdatas.price)/1 >= this.offerslist.minimumBid)){
          return false
        }else{
          return true
        }
      }else{
        if(this.formdatas.price && this.formdatas.currency && this.formdatas.expirationDate && this.formdatas.payAccount){
          return false
        }else{
          return true
        }
      }
      
    },
    changemakeoffs(){
      if(this.offerslist.minimumBid){
        if(this.formdatas.price && this.formdatas.currency && this.formdatas.expirationDate && this.formdatas.payAccount && ((this.formdatas.price)/1 >= this.offerslist.minimumBid)){
          return true
        }else{
          return false
        }
      }else{
        if(this.formdatas.price && this.formdatas.currency && this.formdatas.expirationDate && this.formdatas.payAccount){
          return true
        }else{
          return false
        }
      }
    },
    changebuyNow(){
      if(this.buynowform.tradingAccount){
        return false
      }else{
        return true
      }
    },

    //Make offer操作
    postMakeoffer(){
      if(this.token){
        let self = this;
        self.makeoffbool = true
        let request = self.formdatas
        request = {
          tokenId:self.form.id,
          price:self.formdatas.price,
          currency:self.formdatas.currency,
          expirationDate:self.formdatas.expirationDate,
          payAccount:self.formdatas.payAccount,
        }
        self.$store.dispatch("nft/postMakeoffer", request);
        request.callback = function(response){
            if(response.result == 'success'){
              self.$message({type: "success", message: "Make Offer Successfully!"});
              self.makeoffbool = false
              self.$store.dispatch("nft/getTokenById", self.id);
              self.dialogBidVisible = false
              self.dialogmakeVisible = false
            }else{
              self.$message({type: "error", message: response.result});
              self.makeoffbool = false
              self.dialogBidVisible = false
              self.dialogmakeVisible = false
            }
          }
      }else{
        this.gotoLoginPage()
      }
      
    },

    changeCancel(row){
      this.cancelbool = true
      let request = {
        offerId:row.offerId
      }
      if(this.token){
        this.$store.dispatch("nft/changeCancel", request)
        let self = this
        request.callback = function(response){
          if(response.result == 'success'){
            self.$message({type: "success", message: "Cancel Successfully!"});
            self.cancelbool = false
            self.$store.dispatch("nft/getTokenById", self.id);
          }else{
            self.$message({type: "error", message: "Cancel Failed!"});
            self.cancelbool = false
          }
        }
      }else{
        this.gotoLoginPage()
      }
      
    },
    changeAccept(row){
      this.acceptbool = true
      let request = {
        offerId:row.offerId,
        id:this.form.id
      }
      if(this.token){
        this.$store.dispatch("nft/changeAccept", request)
        let self = this
        request.callback = function(response){
          if(response.result == 'success'){
            self.$message({type: "success", message: "Accept Successfully!"});
            self.acceptbool = false
            self.$router.push({path: '/myprofile'})
            // self.$store.dispatch("nft/getTokenById", self.id);
            // location.reload();
          }else{
            self.$message({type: "error", message: response.result});
            self.acceptbool = false
          }
        }
      }else{
        this.gotoLoginPage()
      }
    },
    columnStyle({row, column, rowIndex, columnIndex}) {
      if (columnIndex == 2) {
        //字体颜色
        return "color:#2181E2;";
      }

      if (columnIndex == 1) {
      }
    },
    getdivWidth(){
      const parentClientWidth = this.$refs.barparent.clientWidth;
    },
    handledate(data){
      var startAt = new Date(data).getTime();
      if(startAt <= Date.now()) {
          this.formdatas.expirationDate = new Date(Date.now()+1000 * 60 * 60);
      }
    },
    changeloading(src){
      let img = new Image()
      img.src = src
      let self = this
      img.onload = (()=>{
        self.loading = false
      })
    }
  },
  // 生命周期 - 创建完成（可以访问当前this实例）
  created() {
    this.$store.dispatch("nft/getTokenById", this.id);
    this.$store.dispatch("nft/getCurrencyList");
    this.$store.dispatch("nft/getAccountList");
  },
  // 生命周期 - 挂载完成（可以访问DOM元素）
  mounted() {
    this.token = authority.getToken()
    this.getdivWidth();
    this.routertype = this.$route.query.type
    window.onresize = () => {
        return (() => {
            window.fullWidth = document.documentElement.clientWidth;
            this.windowWidth = window.fullWidth; // 宽
        })()
    }
    // this.$nextTick(()=>{
    //   this.$store.dispatch("nft/getNFTasset", {tokenId:this.form.id});
    //   this.$store.dispatch("nft/changebutton", {id:this.form.id});
    // })
  },
  beforeCreate() {
  }, // 生命周期 - 创建之前
  beforeMount() {
  }, // 生命周期 - 挂载之前
  beforeUpdate() {
  }, // 生命周期 - 更新之前
  updated() {
  }, // 生命周期 - 更新之后
  beforeDestroy() {
  }, // 生命周期 - 销毁之前
  destroyed() {
  }, // 生命周期 - 销毁完成
  activated() {
  } // 如果页面有keep-alive缓存功能，这个函数会触发
}
</script>
<style lang='scss' scoped>
// @import url(); 引入公共css类
.new_box{
    height:420px;
    background: url('../../assets/img/btcbj.png') no-repeat;
    background-size: cover;
    font-size:16px;
    color:#7d91aa;
}
::v-deep .el-breadcrumb__inner{
        color:#C8C8C8 !important;
        font-size:16px !important;
    }
.sp{
    padding-top:90px;
    padding-bottom:90px;
    .el-row{
        margin-top:10%;
    }
    .col_list{
        padding:10px;
        margin-bottom:20px;
    }
}
.ban_box {
  // width: 900px;
  margin: 0 auto;
  max-width: 100%;
  padding: 0 20px;
}

.bg_box {
  height: 60px;
  line-height: 60px;

  p {
    font-size: 14px;
    font-family: ArialMT;
    color: #161616;
    cursor: pointer;
  }
}

::v-deep .divder_box {
  .el-divider--horizontal {
    margin: 0;
  }

  .el-divider {
    background-color: #F3F5F8;
  }
}

.banner_box {
  padding: 37px 20px;
  display: flex;
  flex-direction: row;

  .first_flex {
    flex: 3 0 0%;
    max-width: 32%;
    width: 0;

    .img_box {
      padding: 22px 15px 30px 15px;
      border: 1px solid #E7EAED;
      border-radius: 4px;
    }
  }

  .two_flex {
    flex: 4 0 0%;
    margin-left: 20px;
  }
}

::v-deep .bg_coll_box {
  .el-collapse-item__content {
    background: #F7FAFC;
  }
}

::v-deep .collpass_box {
  margin-top: 20px;
  border: 1px solid #E7EAED;

  .el-collapse-item__header {
    border-bottom: 1px solid #E7EAED;
    padding-left: 15px;
    padding-right: 5px;
    font-size: 14px;
    font-family: Arial-BoldMT, Arial;
    font-weight: 600;
    color: #161616;
    line-height: 16px;
  }

  .el-icon-arrow-right:before {
    content: url('../../assets/img/icon_right.png');
  }
  .right_btn_box{
    .el-icon-arrow-right:before {
      content: "\e6e0";
    }
  }

  .el-collapse-item__arrow.is-active {
    transform: rotate(180deg);
    -webkit-transform: rotate(180deg)
  }

  .el-collapse-item__content {
    padding: 23px 15px 23px 15px;
    font-size: 12px;
    font-family: ArialMT;
    color: #8A949C;
    line-height: 16px;
  }

  .coll_flex {
    display: flex;
    justify-content: space-between;
    margin:15px 0;

    p {
      font-size: 12px;
      font-family: ArialMT;
      color: #8A949C;
      line-height: 14px;
    }
    a{
      color: #007bff;
      text-decoration: none;
      background-color: transparent;
      -webkit-text-decoration-skip: objects;
    }
  }

  .collmon_box {
    p {
      font-size: 14px;
      font-family: ArialMT;
      color: #8A949C;
      line-height: 16px;
    }

    h3 {
      font-size: 30px;
      font-family: Arial-BoldMT, Arial;
      font-weight: 700;
      color: #161616;
      line-height: 34px;
      display: flex;

      p {
        font-size: 16px;
        font-family: ArialMT;
        color: #353840;
        line-height: 40px;
        margin-left: 5px;
      }

      span {
        font-size: 14px;
        font-family: ArialMT;
        color: #8A949C;
        line-height: 40px;
        margin-left: 10px;
      }
    }

    .buy_btn {
      width: 40%;

      img {
        padding-right: 10px;
        padding-bottom: 5px;
      }
    }

    .tab_btn {
      font-size: 12px;
      font-family: ArialMT;
      color: #2181E2 !important;
      line-height: 14px;
    }
  }
}

.right_box {
  display: flex;
  justify-content: space-between;

  .yuan {
    width: 20px;
    height: 20px;
    border: 0.1px solid #2181E2;
    border-radius: 50%;
    margin-right: 10px;
    margin-top:2px;
    background: linear-gradient(180deg, #45B7F3 0%, #2181E2 100%);;
  }

  h3 {
    font-size: 24px;
    font-family: Arial-BoldMT, Arial;
    font-weight: 600;
    color: #161616;
    line-height: 28px;
    margin-bottom: 25px;
  }

  p {
    font-size: 14px;
    font-family: ArialMT;
    color: #8A949C;
    line-height: 25px;
  }

  span {
    font-size: 14px;
    font-family: ArialMT;
    color: #2181E2;
    line-height: 25px;
    margin-left: 5px;
    cursor: pointer
  }
}

::v-deep .top_btn_box {
  .el-button {
    padding-left: 30px;
    padding-right: 30px;
    font-size: 12px;
    font-family: Arial-BoldMT, Arial;
    font-weight: normal;
  }

  .bg_btn {
    border: 1px solid #2181E2;
    color: #2181E2;
  }
}

::v-deep .bg_btn_box {
  padding-left: 40px;
  padding-right: 40px;
  border: 1px solid #2181E2;
  color: #2181E2;
  font-size: 12px;
  font-family: Arial-BoldMT, Arial;
  font-weight: 600;
  margin-top: 18px;
}
.dialog_box_p{
  font-size: 24px !important;
  font-family: PingFangSC-Medium, PingFang SC;
  font-weight: 600;
  color: #161616 !important;
  margin-bottom:24px;
  margin-top:24px;
}
::v-deep .el-tag{
  height: 24px;
  line-height: 20px;
  padding:0 20px;
  font-size:14px;
  margin-top:10px;
  margin-bottom:30px;
}
::v-deep .el-tag.el-tag--success{
  background-color:rgba(30,188,118,0.1);
  color:#00B464;
}
::v-deep .el-tag.el-tag--danger{
  background-color:rgba(245,108,108,0.1);
  color:#F56C6C;
}
::v-deep .dia_sele_box{
  margin:0 auto;
  input[type="text"], select, textarea{
    background: #FFFFFF !important;
    border-right: none;
  }
  .el-form-item__label{
    font-size: 14px;
    font-family: ArialMT;
    color: #A6B0BE;
  }
  .el-form-item__label:first{
    margin-left:16%;
  }
  // .el-select .el-input {
  //   width: 100px;
  // }
  .input-with-select .el-input-group__prepend {
    background-color: #fff;
  }
}

@media (min-width: 1400px) {
  .ban_box {
    width: 1280px;
  }
}
@media (max-width: 980px) {
  .banner_box {
    flex-wrap: wrap;
    .first_flex{
      flex: 0 0 100%;
      max-width: 100%;
    }
    .two_flex{
      flex: 0 0 100%;
      max-width: 100%;
      margin-left: 0;
    }
  }
}

</style>
